import { useGraphql } from 'utils/hooks/useGraphql';
import { ResourceSelect } from '../../../editorComponents/ResourceSelect/ResourceSelect';
import { fetchMessageTypes } from './graphql';
import { ResourceComponentProps } from './types';
import { parseMessageTypeOption } from './utils';

export const ResourceMessageTypeSelect = (props: ResourceComponentProps) => {
  const { data, isLoading, error } = useGraphql(fetchMessageTypes);

  return (
    <ResourceSelect
      noResourceHelpText=""
      {...props}
      data-formfieldtype="select"
      data-selectoptiontype="campaign"
      options={data?.messageTypes?.map(parseMessageTypeOption) ?? []}
      isError={error || props.isError}
      isLoading={isLoading}
    />
  );
};
